import React, { useState } from 'react'
import { Col, Panel, Row } from 'rsuite'
import { useHistory } from 'react-router-dom'
import pathname from '../../../constants/pathname'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { sessionRemoveItem, sessionSetItemObj } from '../../../utils/sessionHelpers'
import { startLoading, doneLoading } from '../../../utils/loading'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import { cloneDeep } from 'lodash-es'
import BlacklistedSearchForm from './BlacklistedSearchForm'
import BlacklistedTable from './BlacklistedTable'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { editBlacklisted, searchBlacklisted } from '../../../redux/actions/blacklist'
import { useForm } from 'react-hook-form'

export default function BlacklistedWidget(props) {
  const {} = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [searchRequest, setSearchRequest] = useState({})
  const history = useHistory()
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [isViewMode, setIsViewMode] = useState(props.isViewMode)
  const [selectRowData, setSelectRowData] = useState()

  // console.log('formSchema', formSchema)

  const onSearch = (request) => {
    // console.log('test', pageNum, pageSize, request)
    handleSearch(1, displayLength, request)
  }

  const handleSearch = async (pageNum, pageSize, request) => {
    setIsLoading(true)
    startLoading()
    try {
      console.log('handleSearch', pageNum, pageSize, request)
      setPage(pageNum)
      setDisplayLength(pageSize)
      setSearchRequest(request)

      const response = await searchBlacklisted(pageNum, pageSize, request)
      console.log('response ', response)
      var _schema = cloneDeep(formSchema)

      _schema.result = response.model

      setFormSchema(_schema)
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onReload = (pagenumber, pagesize) => {
    handleSearch(pagenumber, pagesize, searchRequest)
  }

  const handleSelect = (rowData, type) => {
    // console.log('handleSelect ', rowData, type)
    // handleGetSchemaEdit(rowData.id)
    if (rowData) {
      sessionSetItemObj('blacklistedId', { blacklistedId: rowData.id, editMode: type == 'view' })
    }

    history.push({
      pathname: pathname.blacklist.AddBlacklist,
    })
  }

  const handleGetSchemaEdit = async (rowData) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await editBlacklisted(rowData)
      setSelectRowData(response.model)
      console.log('editBlacklisted', response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSelect = () => {
    history.push({
      pathname: `${pathname.blacklist.AddBlacklist}`,
    })
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={formSchema?.header} bordered>
        <BlacklistedSearchForm
          schema={formSchema.searchForm}
          loading={isLoading}
          onSearch={onSearch}
        />

        <div style={{ marginTop: 20 }}>
          <Row>
            <Col lg={8} md={8} sm={24} xs={24}></Col>
            {/* {schema?.isEnableEdit && ( */}
            <Col lg={16} md={16} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <SaveButton
                icon="plus-square"
                disabled={false}
                onClick={() => {
                  sessionRemoveItem('blacklistedId')
                  handleSelect(null, 'edit')
                }}
                style={{
                  marginRight: 10,
                }}
              >
                เพิ่มข้อมูลผู้ทิ้งาน
              </SaveButton>
            </Col>
            {/* )} */}
          </Row>
        </div>

        <BlacklistedTable
          schema={formSchema.result}
          loading={isLoading}
          onReload={onReload}
          page={page}
          displayLength={displayLength}
          isViewMode={isViewMode}
          onSelect={handleSelect}
        />

        {isLoading && <OverlayLoader />}
      </Panel>
    </>
  )
}
